import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "../utilities/context";
import { FormattedMessage, useIntl } from "react-intl";
import Container from "@mui/material/Container";
import Layout from "./Layout";
import Grid from "@mui/material/Grid";
import Styles from "../../public/assets/css/main.css";
import logoHome from "../../public/assets/images/detailLogo.png";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import TelegramIcon from "@mui/icons-material/Telegram";
import QrCodeIcon from "@mui/icons-material/QrCode";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CheckIcon from "@mui/icons-material/Check";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import LocalConvenienceStoreIcon from '@mui/icons-material/LocalConvenienceStore';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import GroupsIcon from '@mui/icons-material/Groups';

// import Chat from "./Chat";

const Home = () => {
  const context = useContext(AppContext);
  const intl = useIntl();

  useEffect(() => {
    if (context) {
      context.updateBreadcrumbsState([]);
    }
  }, []); // The empty dependency array means this effect will only run once (equivalent to componentDidMount)

  return (
    <Layout>
      <Container maxWidth={false} disableGutters>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={1}>
            &nbsp;
          </Grid>
          <Grid item xs={12} sm={12} sx={{ textAlign: "center" }}>
            <FormattedMessage id="app.home.slogan" />
          </Grid>
          <Grid item xs={12} sm={6} sx={{ textAlign: "center" }}>
            <img src={logoHome} className={"AppLogoHome"} alt="logo" />
          </Grid>
          <Grid item xs={12} md={6}>
            <List dense={true}>
              <ListItem>
                <ListItemIcon>
                  <AddShoppingCartIcon fontSize="large" color="primary" />
                </ListItemIcon>
                  <ListItemText
                    primary={intl.formatMessage({
                      id: "app.home.bullet1",
                    })}
                  />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <QueryStatsIcon fontSize="large" color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary={intl.formatMessage({
                    id: "app.home.bullet2",
                  })}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <LocalConvenienceStoreIcon fontSize="large" color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary={intl.formatMessage({
                    id: "app.home.bullet3",
                  })}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <GroupsIcon fontSize="large" color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary={intl.formatMessage({
                    id: "app.home.bullet4",
                  })}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <AssignmentReturnIcon fontSize="large" color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary={intl.formatMessage({
                    id: "app.home.bullet5",
                  })}
                />
              </ListItem>
            </List>
          </Grid>
          <Grid item xs={12} sm={12} sx={{ textAlign: "center" }}>
            <Link to={"mailto:info@plopi.com.ar"}>
              <FormattedMessage id="app.footer.contact.title" />
            </Link>{" "}|{" "}
            <Link to={"/terms"}>
              <FormattedMessage id="app.terms.title" />
            </Link>{" "}|{" "}
            <Link to={"/privacy"}>
              <FormattedMessage id="app.privacy.title" />
            </Link>
          </Grid>
        </Grid>
        {/* <Chat /> */}
      </Container>
    </Layout>
  );
};

export default Home;
